interface PaginationControlsProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export function PaginationControls({ page, totalPages, onPageChange, disabled }: PaginationControlsProps) {
  if (totalPages <= 1) return null;

  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
        alignItems: 'center',
        marginTop: '1rem'
      }}
    >
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={!canPrev || disabled}
        style={{
          padding: '0.45rem 0.95rem',
          borderRadius: '8px',
          border: '1px solid var(--color-border)',
          background: '#fff',
          cursor: canPrev && !disabled ? 'pointer' : 'not-allowed'
        }}
      >
        Previous
      </button>
      <div className="text-muted">
        Page {page} of {Math.max(totalPages, 1)}
      </div>
      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={!canNext || disabled}
        style={{
          padding: '0.45rem 0.95rem',
          borderRadius: '8px',
          border: '1px solid var(--color-border)',
          background: '#fff',
          cursor: canNext && !disabled ? 'pointer' : 'not-allowed'
        }}
      >
        Next
      </button>
    </div>
  );
}

